module.exports = __webpack_public_path__ + "img/ddp.3b2ff598.svg";